module.exports = __webpack_public_path__ + "img/Yaoqi_Zhou.8b908314.png";